export default {
  start: {
    id: 0,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-sunny.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-start-end.png",
    title: "Total Roofing Protection is more than shingle-deep.",
    paragraph: "Choose beauty that performs with a complete roofing system.",
    ctaText: "See the Three Part System",
    ctaTarget: "seal"
  },
  seal: {
    id: 1,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-stormy.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-seal.png",
    iconUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/seal.svg",
    title: "Helps create a water-proof barrier.",
    paragraph: "Block water resulting from ice damming, wind-driven rains and normal water flow. A properly sealed roof helps prevent rot and mold.",
    ctaText: "Why Seal",
    ctaTarget: "sealInner"
  },
  sealInner: {
    id: 2,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-stormy.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-seal.png",
    backTarget: "seal",
    title: "Block water resulting from ice damming, wind-driven rains and normal water flow.",
    paragraph: "A properly sealed roof helps prevent rot and mold.",
    innerPhotos: [
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/mold.jpg",
        title: "Mold"
      },
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/rot.jpg",
        title: "Rot"
      }
    ],
    ctaText: "Why Defend",
    ctaTarget: "defend"
  },
  defend: {
    id: 3,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-partly-cloudy.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-defend.png",
    iconUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/defend.svg",
    title: "Helps protect against nature's elements.",
    paragraph: "Add a tough, yet beautiful layer of defense with strong adhesion that resists blow offs and helps shed water away from the roof deck. Helps protect the most vulnerable areas such as eaves and peaks.",
    ctaText: "Why Defend",
    ctaTarget: "defendInner"
  },
  defendInner: {
    id: 4,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-partly-cloudy.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-defend.png",
    backTarget: "defend",
    title: "Add a tough, yet beautiful, layer of defense with strong adhesion that resists blow offs and helps shed water away from the roof deck.",
    paragraph: "Helps protect the most vulnerable areas such as eaves and peaks.",
    innerPhotos: [
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/blow-off.jpg",
        title: "Blow Off"
      },
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/impact.jpg",
        title: "Impact"
      }
    ],
    ctaText: "Why Breathe",
    ctaTarget: "breathe"
  },
  breathe: {
    id: 5,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-sunny.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-breathe.png",
    iconUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/breathe.svg",
    title: "For balanced attic ventilation.",
    paragraph: "Reduces heat and moisture buildup that can lead to ice damming, roof deterioration, and mold infestation. This helps air flow through the attic to manage temperature and moisture.",
    ctaText: "Why Breathe",
    ctaTarget: "breatheInner"
  },
  breatheInner: {
    id: 6,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-sunny.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-breathe.png",
    backTarget: "breathe",
    title: "Reduce heat and moisture buildup that can lead to ice damming, roof deterioration and mold infestation.",
    paragraph: "Helps air flow through the attic to manage temperature and moisture.",
    innerPhotos: [
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/mold.jpg",
        title: "Mold"
      },
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/ice-damming.jpg",
        title: "Ice Damming"
      },
      {
        imageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/inner-photos/heat-buildup.jpg",
        title: "Heat Buildup"
      }
    ],
    ctaText: "Get in Touch",
    ctaTarget: "end"
  },
  end: {
    id: 7,
    bodyImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-sunny.jpg",
    roofImageUrl: "https://d10dvh97d9q6kg.cloudfront.net/static/images/tprs/tprs-start-end.png",
    title: "Contact us today to schedule an estimate."
  }
}
